import React from 'react';
import './Footer.css'

const Footer: React.FC = () => {
    return (
        <footer>
            <p>Made by <a href="https://github.com/michaelkolesidis/react-landmarks" target="_blank" rel="noreferrer noopener">Michael Kolesidis</a></p>
        </footer>
    )
}

export default Footer;